import React, { useState, useEffect } from 'react';
import { useLanguage } from '../../providers/preferenceProvider';
import { deleteRegistration, getRegistrations, resendRegistration } from '../../api/registration-api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useToast } from "../../providers/toastProvider";
import '../../css/overlay.css';

const PendingInvites = ({ isOpen, onClose }) => {
  const { t } = useLanguage();
  const [invites, setInvites] = useState([]);
  const { showToast, showActionToast, showLoading, hideLoading } = useToast();

  async function fetchData() {
    try {
      const response = await getRegistrations();
      setInvites(response.data);
    } catch (error) {
      console.error("Error fetching pending invites:", error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  if (!isOpen) return null;

  const handleResendInvite = async (email, inviteId) => {
    showLoading();
    try {
      await resendRegistration(inviteId);
      hideLoading();
      showToast(t.toast.register_send_message.replace('{ph_name}', email), 'success');
    } catch (error) {
      hideLoading();
    }
  }

  const deleteConfirmation = (email, inviteId) => {
    showActionToast(
      t.toast.confirm_delete_general.replace('{ph_name}', email),
      () => handleDeleteInvite(inviteId),
      null
    );
  }

  const handleDeleteInvite = async (inviteId) => {
    showLoading();
    try {
      await deleteRegistration(inviteId);
      fetchData();
      showToast(t.toast.deleted_success.replace('{ph_name}', t.invite), 'success');
      hideLoading();
    } catch (error) {
      hideLoading();
    }
  }

  return (
    <div className="overlay-backdrop" onClick={onClose}>
      <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
        <div className="overlay-header">{t.pending_registrations}</div>
        <div className="admin-list-box">
          <div className="admin-list-header grid-cols-[1.5fr_1fr_1.5fr] text-gray-600 px-4 py-2">
            <div className="cursor-pointer select-none">
              {t.email}
            </div>
            <div className="cursor-pointer select-none">
              {t.company}
            </div>
            <div></div>
          </div>
          {invites.length > 0 ? (
            invites.map((invite, index) => (
              <div key={index} className="grid md:grid-cols-[1.5fr_1fr_1.5fr] items-center px-3 py-2 rounded-md m-2 bg-white">
                <div className="text-xs admin-list-cell" title={invite.email}>{invite.email}</div>
                <div className="admin-list-cell"><h3>{invite.company?.name}</h3></div>
                <div className="text-right admin-list-cell">
                  <button className="admin-edit-button" onClick={() => handleResendInvite(invite.email, invite.uuid)}> 
                    {t.resend} <FontAwesomeIcon icon={faEnvelope} />
                  </button>
                  <button className="admin-edit-button" onClick={() => deleteConfirmation(invite.email, invite.uuid)} > 
                    {t.delete} <FontAwesomeIcon icon={faTrash} />
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center text-gray-500 py-4">
              {t.no_results}
            </div>
          )}
        </div>

        <div className="flex flex-row-reverse mt-4 gap-2">
          <button className="btn-close" onClick={onClose}>{t.close}</button>
        </div>
      </div>
    </div>
  );
};


export default PendingInvites;